// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExchangeTransaction_upper__metrics__FqXSm {
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 5rem;
  margin-top: 5rem;
}
@media only screen and (max-width: 62.5em) {
  .ExchangeTransaction_upper__metrics__FqXSm {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 56.25em) {
  .ExchangeTransaction_upper__metrics__FqXSm {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .ExchangeTransaction_upper__metrics__FqXSm {
    grid-template-columns: repeat(2, 1fr);
  }
}
.ExchangeTransaction_upper__metrics_totalBiz__4EhV- {
  background-color: var(--color-primary-3);
}
.ExchangeTransaction_upper__metrics_totalAmount__6RJih {
  background-color: var(--color-green);
  color: var(--color-white);
}
.ExchangeTransaction_upper__metrics_totalCount__7bFWK {
  background-color: var(--color-yellow);
}

.ExchangeTransaction_filterSection__ehTR6 {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 3rem;
}

.ExchangeTransaction_modal__RmiWO {
  width: 38rem;
}
.ExchangeTransaction_modal__RmiWO > :not(:last-child) {
  margin-bottom: 1rem;
}
.ExchangeTransaction_modal__beside__9U4KV {
  display: flex;
  justify-content: space-between;
}

.ExchangeTransaction_main_nav__0\\+ind {
  display: flex;
  margin: 2rem 0;
  border-bottom: solid 1px var(--color-dark);
  gap: 2rem;
  width: fit-content;
}
.ExchangeTransaction_main_nav_item__0yh-I {
  cursor: pointer;
  padding: 1rem 0;
  font-size: var(--default-font-small);
}
.ExchangeTransaction_main_nav_item_active__l1tNC {
  cursor: pointer;
  padding: 1rem 0;
  font-weight: 700;
  border-bottom: solid 2px var(--color-dark);
}
.ExchangeTransaction_main_nav_item__0yh-I:hover, .ExchangeTransaction_main_nav_item__0yh-I:focus, .ExchangeTransaction_main_nav_item__0yh-I:focus-visible, .ExchangeTransaction_main_nav_item__0yh-I:focus-within {
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/ExchangeTransaction/ExchangeTransaction.module.scss"],"names":[],"mappings":"AAGC;EACC,sBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAFF;AAIE;EATD;IAUE,qCAAA;EADD;AACF;AAGE;EAbD;IAcE,qCAAA;EAAD;AACF;AAEE;EAjBD;IAkBE,qCAAA;EACD;AACF;AACE;EACC,wCAAA;AACH;AAEE;EACC,oCAAA;EACA,yBAAA;AAAH;AAGE;EACC,qCAAA;AADH;;AAMA;EACC,aAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;AAHD;;AAMA;EACC,YAAA;AAHD;AAKC;EACC,mBAAA;AAHF;AAMC;EACC,aAAA;EACA,8BAAA;AAJF;;AASC;EACC,aAAA;EACA,cAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;AANF;AAQE;EACC,eAAA;EACA,eAAA;EACA,oCAAA;AANH;AAQG;EACC,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;AANJ;AASG;EAIC,gBAAA;AAVJ","sourcesContent":["@import '../variables/breakpoints';\n\n.upper {\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\tgap: 1rem;\n\t\tmargin-bottom: 5rem;\n\t\tmargin-top: 5rem;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t&_totalBiz {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t}\n\n\t\t&_totalAmount {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_totalCount {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\t}\n}\n\n.filterSection {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: space-between;\n\tmargin-top: 3rem;\n}\n\n.modal {\n\twidth: 38rem;\n\n\t&> :not(:last-child) {\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n}\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tmargin: 2rem 0;\n\t\tborder-bottom: solid 1px var(--color-dark);\n\t\tgap: 2rem;\n\t\twidth: fit-content;\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tborder-bottom: solid 2px var(--color-dark);\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper__metrics": `ExchangeTransaction_upper__metrics__FqXSm`,
	"upper__metrics_totalBiz": `ExchangeTransaction_upper__metrics_totalBiz__4EhV-`,
	"upper__metrics_totalAmount": `ExchangeTransaction_upper__metrics_totalAmount__6RJih`,
	"upper__metrics_totalCount": `ExchangeTransaction_upper__metrics_totalCount__7bFWK`,
	"filterSection": `ExchangeTransaction_filterSection__ehTR6`,
	"modal": `ExchangeTransaction_modal__RmiWO`,
	"modal__beside": `ExchangeTransaction_modal__beside__9U4KV`,
	"main_nav": `ExchangeTransaction_main_nav__0+ind`,
	"main_nav_item": `ExchangeTransaction_main_nav_item__0yh-I`,
	"main_nav_item_active": `ExchangeTransaction_main_nav_item_active__l1tNC`
};
export default ___CSS_LOADER_EXPORT___;
